// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function knowledgeBaseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.knowledgeSourceKeys !== undefined) {
        o['knowledgeSourceKeys'] = m.knowledgeSourceKeys.map(e => knowledgeSourceKeyToJson(e));
    }
    return o;
}
export function knowledgeBaseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        knowledgeSourceKeys: ((_d = o['knowledgeSourceKeys']) !== null && _d !== void 0 ? _d : []).map(e => knowledgeSourceKeyFromJson(e)),
    };
}
export function knowledgeBaseKeyToJson(m) {
    const o = {};
    if (m.knowledgeBaseId !== undefined)
        o['knowledgeBaseId'] = m.knowledgeBaseId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function knowledgeBaseKeyFromJson(o) {
    var _a;
    return {
        knowledgeBaseId: (_a = o['knowledgeBaseId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function knowledgeSourceToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.config !== undefined)
        o['config'] = knowledgeSourceConfigToJson(m.config);
    if (m.knowledgeBaseKeys !== undefined) {
        o['knowledgeBaseKeys'] = m.knowledgeBaseKeys.map(e => knowledgeBaseKeyToJson(e));
    }
    if (m.training !== undefined)
        o['training'] = knowledgeSourceTrainingToJson(m.training);
    return o;
}
export function knowledgeSourceFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        config: o['config'] ? knowledgeSourceConfigFromJson(o['config']) : undefined,
        knowledgeBaseKeys: ((_d = o['knowledgeBaseKeys']) !== null && _d !== void 0 ? _d : []).map(e => knowledgeBaseKeyFromJson(e)),
        training: o['training'] ? knowledgeSourceTrainingFromJson(o['training']) : undefined,
    };
}
export function knowledgeSourceKeyToJson(m) {
    const o = {};
    if (m.knowledgeSourceId !== undefined)
        o['knowledgeSourceId'] = m.knowledgeSourceId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function knowledgeSourceKeyFromJson(o) {
    var _a;
    return {
        knowledgeSourceId: (_a = o['knowledgeSourceId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function knowledgeSourceTrainingToJson(m) {
    const o = {};
    if (m.progress !== undefined)
        o['progress'] = m.progress;
    if (m.totalUnits !== undefined)
        o['totalUnits'] = m.totalUnits;
    if (m.completedUnits !== undefined)
        o['completedUnits'] = m.completedUnits;
    if (m.error !== undefined)
        o['error'] = knowledgeSourceTrainingErrorToJson(m.error);
    return o;
}
export function knowledgeSourceTrainingFromJson(o) {
    var _a, _b, _c;
    return {
        progress: (_a = o['progress']) !== null && _a !== void 0 ? _a : 'TRAINING_INVALID',
        totalUnits: (_b = o['totalUnits']) !== null && _b !== void 0 ? _b : 0,
        completedUnits: (_c = o['completedUnits']) !== null && _c !== void 0 ? _c : 0,
        error: o['error'] ? knowledgeSourceTrainingErrorFromJson(o['error']) : undefined,
    };
}
export function knowledgeSourceTrainingErrorToJson(m) {
    const o = {};
    if (m.code !== undefined)
        o['code'] = m.code;
    return o;
}
export function knowledgeSourceTrainingErrorFromJson(o) {
    var _a;
    return {
        code: (_a = o['code']) !== null && _a !== void 0 ? _a : 'ERROR_CODE_UNSET',
    };
}
export function knowledgeSourceConfigToJson(m) {
    const o = {};
    if (m.config !== undefined) {
        if (m.config.type === 'businessProfileConfig') {
            o['businessProfileConfig'] = knowledgeSourceConfigBusinessProfileConfigToJson(m.config.businessProfileConfig);
        }
        if (m.config.type === 'customDataConfig') {
            o['customDataConfig'] = knowledgeSourceConfigCustomDataConfigToJson(m.config.customDataConfig);
        }
        if (m.config.type === 'websiteScrapeConfig') {
            o['websiteScrapeConfig'] = knowledgeSourceConfigWebsiteScrapeConfigToJson(m.config.websiteScrapeConfig);
        }
        if (m.config.type === 'fileConfig') {
            o['fileConfig'] = knowledgeSourceConfigFileConfigToJson(m.config.fileConfig);
        }
    }
    else {
        if (m.businessProfileConfig !== undefined)
            o['businessProfileConfig'] = knowledgeSourceConfigBusinessProfileConfigToJson(m.businessProfileConfig);
        if (m.customDataConfig !== undefined)
            o['customDataConfig'] = knowledgeSourceConfigCustomDataConfigToJson(m.customDataConfig);
        if (m.websiteScrapeConfig !== undefined)
            o['websiteScrapeConfig'] = knowledgeSourceConfigWebsiteScrapeConfigToJson(m.websiteScrapeConfig);
        if (m.fileConfig !== undefined)
            o['fileConfig'] = knowledgeSourceConfigFileConfigToJson(m.fileConfig);
    }
    return o;
}
export function knowledgeSourceConfigFromJson(o) {
    return {
        config: (() => {
            if (o['businessProfileConfig'] !== undefined)
                return { type: 'businessProfileConfig', businessProfileConfig: o['businessProfileConfig'] ? knowledgeSourceConfigBusinessProfileConfigFromJson(o['businessProfileConfig']) : undefined };
            if (o['customDataConfig'] !== undefined)
                return { type: 'customDataConfig', customDataConfig: o['customDataConfig'] ? knowledgeSourceConfigCustomDataConfigFromJson(o['customDataConfig']) : undefined };
            if (o['websiteScrapeConfig'] !== undefined)
                return { type: 'websiteScrapeConfig', websiteScrapeConfig: o['websiteScrapeConfig'] ? knowledgeSourceConfigWebsiteScrapeConfigFromJson(o['websiteScrapeConfig']) : undefined };
            if (o['fileConfig'] !== undefined)
                return { type: 'fileConfig', fileConfig: o['fileConfig'] ? knowledgeSourceConfigFileConfigFromJson(o['fileConfig']) : undefined };
            return undefined;
        })(),
        businessProfileConfig: o['businessProfileConfig'] !== undefined ? o['businessProfileConfig'] ? knowledgeSourceConfigBusinessProfileConfigFromJson(o['businessProfileConfig']) : undefined : undefined,
        customDataConfig: o['customDataConfig'] !== undefined ? o['customDataConfig'] ? knowledgeSourceConfigCustomDataConfigFromJson(o['customDataConfig']) : undefined : undefined,
        websiteScrapeConfig: o['websiteScrapeConfig'] !== undefined ? o['websiteScrapeConfig'] ? knowledgeSourceConfigWebsiteScrapeConfigFromJson(o['websiteScrapeConfig']) : undefined : undefined,
        fileConfig: o['fileConfig'] !== undefined ? o['fileConfig'] ? knowledgeSourceConfigFileConfigFromJson(o['fileConfig']) : undefined : undefined,
    };
}
export function knowledgeSourceConfigBusinessProfileConfigToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function knowledgeSourceConfigBusinessProfileConfigFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function knowledgeSourceConfigCustomDataConfigToJson(m) {
    const o = {};
    if (m.content !== undefined) {
        if (m.content.type === 'text') {
            o['text'] = m.content.text;
        }
    }
    else {
        if (m.text !== undefined)
            o['text'] = m.text;
    }
    return o;
}
export function knowledgeSourceConfigCustomDataConfigFromJson(o) {
    return {
        content: (() => {
            if (o['text'] !== undefined)
                return { type: 'text', text: o['text'] };
            return undefined;
        })(),
        text: o['text'] !== undefined ? o['text'] : undefined,
    };
}
export function knowledgeSourceConfigWebsiteScrapeConfigToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.crawlMode !== undefined)
        o['crawlMode'] = m.crawlMode;
    if (m.scrapedPages !== undefined) {
        o['scrapedPages'] = m.scrapedPages.map(e => knowledgeSourceConfigWebsiteScrapeConfigScrapedPageToJson(e));
    }
    if (m.scrapeProgress !== undefined)
        o['scrapeProgress'] = m.scrapeProgress;
    if (m.lastScraped !== undefined)
        o['lastScraped'] = m.lastScraped.toISOString();
    if (m.error !== undefined)
        o['error'] = knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigErrorToJson(m.error);
    if (m.inProgressScrapedPages !== undefined) {
        o['inProgressScrapedPages'] = m.inProgressScrapedPages.map(e => knowledgeSourceConfigWebsiteScrapeConfigScrapedPageToJson(e));
    }
    if (m.options !== undefined)
        o['options'] = knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptionsToJson(m.options);
    if (m.refreshScheduledFor !== undefined)
        o['refreshScheduledFor'] = m.refreshScheduledFor.toISOString();
    return o;
}
export function knowledgeSourceConfigWebsiteScrapeConfigFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        crawlMode: (_b = o['crawlMode']) !== null && _b !== void 0 ? _b : 'WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_INVALID',
        scrapedPages: ((_c = o['scrapedPages']) !== null && _c !== void 0 ? _c : []).map(e => knowledgeSourceConfigWebsiteScrapeConfigScrapedPageFromJson(e)),
        scrapeProgress: (_d = o['scrapeProgress']) !== null && _d !== void 0 ? _d : 'WEBSITE_SCRAPE_CONFIG_PROGRESS_INVALID',
        lastScraped: o['lastScraped'] ? new Date(o['lastScraped']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        error: o['error'] ? knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigErrorFromJson(o['error']) : undefined,
        inProgressScrapedPages: ((_e = o['inProgressScrapedPages']) !== null && _e !== void 0 ? _e : []).map(e => knowledgeSourceConfigWebsiteScrapeConfigScrapedPageFromJson(e)),
        options: o['options'] ? knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptionsFromJson(o['options']) : undefined,
        refreshScheduledFor: o['refreshScheduledFor'] ? new Date(o['refreshScheduledFor']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function knowledgeSourceConfigWebsiteScrapeConfigScrapedPageToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    if (m.trainingEnabled !== undefined)
        o['trainingEnabled'] = m.trainingEnabled;
    if (m.lastScraped !== undefined)
        o['lastScraped'] = m.lastScraped.toISOString();
    if (m.doneScraping !== undefined)
        o['doneScraping'] = m.doneScraping;
    return o;
}
export function knowledgeSourceConfigWebsiteScrapeConfigScrapedPageFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        title: (_b = o['title']) !== null && _b !== void 0 ? _b : '',
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
        trainingEnabled: (_d = o['trainingEnabled']) !== null && _d !== void 0 ? _d : false,
        lastScraped: o['lastScraped'] ? new Date(o['lastScraped']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        doneScraping: (_e = o['doneScraping']) !== null && _e !== void 0 ? _e : false,
    };
}
export function knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigErrorToJson(m) {
    const o = {};
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigErrorFromJson(o) {
    var _a;
    return {
        errorMessage: (_a = o['errorMessage']) !== null && _a !== void 0 ? _a : '',
    };
}
export function knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptionsToJson(m) {
    const o = {};
    if (m.disableAutoTraining !== undefined)
        o['disableAutoTraining'] = m.disableAutoTraining;
    if (m.automaticRefreshTime !== undefined)
        o['automaticRefreshTime'] = m.automaticRefreshTime;
    if (m.excludedUrlPaths !== undefined) {
        o['excludedUrlPaths'] = m.excludedUrlPaths.map(e => e);
    }
    return o;
}
export function knowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        disableAutoTraining: (_a = o['disableAutoTraining']) !== null && _a !== void 0 ? _a : false,
        automaticRefreshTime: (_b = o['automaticRefreshTime']) !== null && _b !== void 0 ? _b : '',
        excludedUrlPaths: ((_c = o['excludedUrlPaths']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function knowledgeSourceConfigFileConfigToJson(m) {
    const o = {};
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.mimetype !== undefined)
        o['mimetype'] = m.mimetype;
    if (m.fileName !== undefined)
        o['fileName'] = m.fileName;
    if (m.queuedFile !== undefined)
        o['queuedFile'] = knowledgeSourceConfigFileConfigFileToJson(m.queuedFile);
    if (m.erroredFile !== undefined)
        o['erroredFile'] = knowledgeSourceConfigFileConfigFileToJson(m.erroredFile);
    return o;
}
export function knowledgeSourceConfigFileConfigFromJson(o) {
    var _a, _b, _c;
    return {
        fileUrl: (_a = o['fileUrl']) !== null && _a !== void 0 ? _a : '',
        mimetype: (_b = o['mimetype']) !== null && _b !== void 0 ? _b : '',
        fileName: (_c = o['fileName']) !== null && _c !== void 0 ? _c : '',
        queuedFile: o['queuedFile'] ? knowledgeSourceConfigFileConfigFileFromJson(o['queuedFile']) : undefined,
        erroredFile: o['erroredFile'] ? knowledgeSourceConfigFileConfigFileFromJson(o['erroredFile']) : undefined,
    };
}
export function knowledgeSourceConfigFileConfigFileToJson(m) {
    const o = {};
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.mimetype !== undefined)
        o['mimetype'] = m.mimetype;
    if (m.fileName !== undefined)
        o['fileName'] = m.fileName;
    return o;
}
export function knowledgeSourceConfigFileConfigFileFromJson(o) {
    var _a, _b, _c;
    return {
        fileUrl: (_a = o['fileUrl']) !== null && _a !== void 0 ? _a : '',
        mimetype: (_b = o['mimetype']) !== null && _b !== void 0 ? _b : '',
        fileName: (_c = o['fileName']) !== null && _c !== void 0 ? _c : '',
    };
}
export function appToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.configurationUrl !== undefined)
        o['configurationUrl'] = m.configurationUrl;
    if (m.knowledgeBaseKeys !== undefined) {
        o['knowledgeBaseKeys'] = m.knowledgeBaseKeys.map(e => knowledgeBaseKeyToJson(e));
    }
    if (m.appType !== undefined)
        o['appType'] = m.appType;
    if (m.appTypeName !== undefined)
        o['appTypeName'] = m.appTypeName;
    if (m.iconUrl !== undefined)
        o['iconUrl'] = m.iconUrl;
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    return o;
}
export function appFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        configurationUrl: (_c = o['configurationUrl']) !== null && _c !== void 0 ? _c : '',
        knowledgeBaseKeys: ((_d = o['knowledgeBaseKeys']) !== null && _d !== void 0 ? _d : []).map(e => knowledgeBaseKeyFromJson(e)),
        appType: (_e = o['appType']) !== null && _e !== void 0 ? _e : '',
        appTypeName: (_f = o['appTypeName']) !== null && _f !== void 0 ? _f : '',
        iconUrl: (_g = o['iconUrl']) !== null && _g !== void 0 ? _g : '',
        externalId: (_h = o['externalId']) !== null && _h !== void 0 ? _h : '',
    };
}
export function appKeyToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function appKeyFromJson(o) {
    var _a;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function appKeyV2ToJson(m) {
    const o = {};
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.appType !== undefined)
        o['appType'] = m.appType;
    return o;
}
export function appKeyV2FromJson(o) {
    var _a, _b;
    return {
        externalId: (_a = o['externalId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        appType: (_b = o['appType']) !== null && _b !== void 0 ? _b : '',
    };
}
export function namespaceToJson(m) {
    const o = {};
    if (m.namespace !== undefined) {
        if (m.namespace.type === 'accountGroupNamespace') {
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.namespace.accountGroupNamespace);
        }
        if (m.namespace.type === 'partnerNamespace') {
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.namespace.partnerNamespace);
        }
        if (m.namespace.type === 'adminNamespace') {
            o['adminNamespace'] = namespaceAdminNamespaceToJson(m.namespace.adminNamespace);
        }
        if (m.namespace.type === 'multiLocationGroupNamespace') {
            o['multiLocationGroupNamespace'] = namespaceMultiLocationGroupNamespaceToJson(m.namespace.multiLocationGroupNamespace);
        }
    }
    else {
        if (m.accountGroupNamespace !== undefined)
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.accountGroupNamespace);
        if (m.partnerNamespace !== undefined)
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.partnerNamespace);
        if (m.adminNamespace !== undefined)
            o['adminNamespace'] = namespaceAdminNamespaceToJson(m.adminNamespace);
        if (m.multiLocationGroupNamespace !== undefined)
            o['multiLocationGroupNamespace'] = namespaceMultiLocationGroupNamespaceToJson(m.multiLocationGroupNamespace);
    }
    return o;
}
export function namespaceFromJson(o) {
    return {
        namespace: (() => {
            if (o['accountGroupNamespace'] !== undefined)
                return { type: 'accountGroupNamespace', accountGroupNamespace: o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined };
            if (o['partnerNamespace'] !== undefined)
                return { type: 'partnerNamespace', partnerNamespace: o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined };
            if (o['adminNamespace'] !== undefined)
                return { type: 'adminNamespace', adminNamespace: o['adminNamespace'] ? namespaceAdminNamespaceFromJson(o['adminNamespace']) : undefined };
            if (o['multiLocationGroupNamespace'] !== undefined)
                return { type: 'multiLocationGroupNamespace', multiLocationGroupNamespace: o['multiLocationGroupNamespace'] ? namespaceMultiLocationGroupNamespaceFromJson(o['multiLocationGroupNamespace']) : undefined };
            return undefined;
        })(),
        accountGroupNamespace: o['accountGroupNamespace'] !== undefined ? o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined : undefined,
        partnerNamespace: o['partnerNamespace'] !== undefined ? o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined : undefined,
        adminNamespace: o['adminNamespace'] !== undefined ? o['adminNamespace'] ? namespaceAdminNamespaceFromJson(o['adminNamespace']) : undefined : undefined,
        multiLocationGroupNamespace: o['multiLocationGroupNamespace'] !== undefined ? o['multiLocationGroupNamespace'] ? namespaceMultiLocationGroupNamespaceFromJson(o['multiLocationGroupNamespace']) : undefined : undefined,
    };
}
export function namespaceAccountGroupNamespaceToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function namespaceAccountGroupNamespaceFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespacePartnerNamespaceToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function namespacePartnerNamespaceFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespaceAdminNamespaceToJson(m) {
    const o = {};
    return o;
}
export function namespaceAdminNamespaceFromJson(o) {
    return {};
}
export function namespaceMultiLocationGroupNamespaceToJson(m) {
    const o = {};
    if (m.multiLocationGroupId !== undefined)
        o['multiLocationGroupId'] = m.multiLocationGroupId;
    return o;
}
export function namespaceMultiLocationGroupNamespaceFromJson(o) {
    var _a;
    return {
        multiLocationGroupId: (_a = o['multiLocationGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function knowledgeBaseGrantToJson(m) {
    const o = {};
    if (m.sourceKb !== undefined)
        o['sourceKb'] = knowledgeBaseKeyToJson(m.sourceKb);
    if (m.targetNamespace !== undefined)
        o['targetNamespace'] = namespaceToJson(m.targetNamespace);
    if (m.targetScope !== undefined)
        o['targetScope'] = m.targetScope;
    if (m.lookupKey !== undefined)
        o['lookupKey'] = m.lookupKey;
    if (m.grantedByUserId !== undefined)
        o['grantedByUserId'] = m.grantedByUserId;
    if (m.grantedByNamespace !== undefined)
        o['grantedByNamespace'] = namespaceToJson(m.grantedByNamespace);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted;
    return o;
}
export function knowledgeBaseGrantFromJson(o) {
    var _a, _b, _c, _d;
    return {
        sourceKb: o['sourceKb'] ? knowledgeBaseKeyFromJson(o['sourceKb']) : undefined,
        targetNamespace: o['targetNamespace'] ? namespaceFromJson(o['targetNamespace']) : undefined,
        targetScope: (_a = o['targetScope']) !== null && _a !== void 0 ? _a : 'TARGET_SCOPE_INVALID',
        lookupKey: (_b = o['lookupKey']) !== null && _b !== void 0 ? _b : '',
        grantedByUserId: (_c = o['grantedByUserId']) !== null && _c !== void 0 ? _c : '',
        grantedByNamespace: o['grantedByNamespace'] ? namespaceFromJson(o['grantedByNamespace']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: (_d = o['deleted']) !== null && _d !== void 0 ? _d : false,
    };
}
export function appKnowledgeBaseAssociationToJson(m) {
    const o = {};
    if (m.appKey !== undefined)
        o['appKey'] = appKeyV2ToJson(m.appKey);
    return o;
}
export function appKnowledgeBaseAssociationFromJson(o) {
    return {
        appKey: o['appKey'] ? appKeyV2FromJson(o['appKey']) : undefined,
    };
}
export function dependentSummaryToJson(m) {
    const o = {};
    if (m.downstreamGrants !== undefined) {
        o['downstreamGrants'] = m.downstreamGrants.map(e => knowledgeBaseGrantToJson(e));
    }
    if (m.appAssociations !== undefined) {
        o['appAssociations'] = m.appAssociations.map(e => appKnowledgeBaseAssociationToJson(e));
    }
    return o;
}
export function dependentSummaryFromJson(o) {
    var _a, _b;
    return {
        downstreamGrants: ((_a = o['downstreamGrants']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeBaseGrantFromJson(e)),
        appAssociations: ((_b = o['appAssociations']) !== null && _b !== void 0 ? _b : []).map(e => appKnowledgeBaseAssociationFromJson(e)),
    };
}
export function embeddingToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.metadata !== undefined)
        o['metadata'] = embeddingMetadataToJson(m.metadata);
    return o;
}
export function embeddingFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
        metadata: o['metadata'] ? embeddingMetadataFromJson(o['metadata']) : undefined,
    };
}
export function embeddingMetadataToJson(m) {
    const o = {};
    if (m.createdBy !== undefined)
        o['createdBy'] = m.createdBy;
    if (m.createdAt !== undefined)
        o['createdAt'] = m.createdAt.toISOString();
    if (m.updatedAt !== undefined)
        o['updatedAt'] = m.updatedAt.toISOString();
    if (m.relationship !== undefined)
        o['relationship'] = embeddingRelationshipToJson(m.relationship);
    if (m.sourceType !== undefined)
        o['sourceType'] = m.sourceType;
    if (m.sourceFeature !== undefined)
        o['sourceFeature'] = m.sourceFeature;
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.citation !== undefined)
        o['citation'] = embeddingCitationToJson(m.citation);
    if (m.disabled !== undefined)
        o['disabled'] = m.disabled;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => tagToJson(e));
    }
    if (m.knowledgeBaseIds !== undefined) {
        o['knowledgeBaseIds'] = m.knowledgeBaseIds.map(e => e);
    }
    if (m.knowledgeBaseKeys !== undefined) {
        o['knowledgeBaseKeys'] = m.knowledgeBaseKeys.map(e => knowledgeBaseKeyToJson(e));
    }
    return o;
}
export function embeddingMetadataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        createdBy: (_a = o['createdBy']) !== null && _a !== void 0 ? _a : '',
        createdAt: o['createdAt'] ? new Date(o['createdAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updatedAt: o['updatedAt'] ? new Date(o['updatedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        relationship: o['relationship'] ? embeddingRelationshipFromJson(o['relationship']) : undefined,
        sourceType: (_b = o['sourceType']) !== null && _b !== void 0 ? _b : 'EMBEDDING_SOURCE_TYPE_INVALID',
        sourceFeature: (_c = o['sourceFeature']) !== null && _c !== void 0 ? _c : '',
        vendorModel: (_d = o['vendorModel']) !== null && _d !== void 0 ? _d : 'EMBEDDING_MODEL_INVALID',
        citation: o['citation'] ? embeddingCitationFromJson(o['citation']) : undefined,
        disabled: (_e = o['disabled']) !== null && _e !== void 0 ? _e : false,
        tags: ((_f = o['tags']) !== null && _f !== void 0 ? _f : []).map(e => tagFromJson(e)),
        knowledgeBaseIds: ((_g = o['knowledgeBaseIds']) !== null && _g !== void 0 ? _g : []).map(e => e),
        knowledgeBaseKeys: ((_h = o['knowledgeBaseKeys']) !== null && _h !== void 0 ? _h : []).map(e => knowledgeBaseKeyFromJson(e)),
    };
}
export function tagToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function tagFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function embeddingRelationshipToJson(m) {
    const o = {};
    if (m.entity !== undefined) {
        if (m.entity.type === 'accountGroup') {
            o['accountGroup'] = embeddingRelationshipAccountGroupToJson(m.entity.accountGroup);
        }
        if (m.entity.type === 'partner') {
            o['partner'] = embeddingRelationshipPartnerToJson(m.entity.partner);
        }
        if (m.entity.type === 'admin') {
            o['admin'] = embeddingRelationshipAdminToJson(m.entity.admin);
        }
    }
    else {
        if (m.accountGroup !== undefined)
            o['accountGroup'] = embeddingRelationshipAccountGroupToJson(m.accountGroup);
        if (m.partner !== undefined)
            o['partner'] = embeddingRelationshipPartnerToJson(m.partner);
        if (m.admin !== undefined)
            o['admin'] = embeddingRelationshipAdminToJson(m.admin);
    }
    return o;
}
export function embeddingRelationshipFromJson(o) {
    return {
        entity: (() => {
            if (o['accountGroup'] !== undefined)
                return { type: 'accountGroup', accountGroup: o['accountGroup'] ? embeddingRelationshipAccountGroupFromJson(o['accountGroup']) : undefined };
            if (o['partner'] !== undefined)
                return { type: 'partner', partner: o['partner'] ? embeddingRelationshipPartnerFromJson(o['partner']) : undefined };
            if (o['admin'] !== undefined)
                return { type: 'admin', admin: o['admin'] ? embeddingRelationshipAdminFromJson(o['admin']) : undefined };
            return undefined;
        })(),
        accountGroup: o['accountGroup'] !== undefined ? o['accountGroup'] ? embeddingRelationshipAccountGroupFromJson(o['accountGroup']) : undefined : undefined,
        partner: o['partner'] !== undefined ? o['partner'] ? embeddingRelationshipPartnerFromJson(o['partner']) : undefined : undefined,
        admin: o['admin'] !== undefined ? o['admin'] ? embeddingRelationshipAdminFromJson(o['admin']) : undefined : undefined,
    };
}
export function embeddingRelationshipAccountGroupToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function embeddingRelationshipAccountGroupFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function embeddingRelationshipPartnerToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function embeddingRelationshipPartnerFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function embeddingRelationshipAdminToJson(m) {
    const o = {};
    return o;
}
export function embeddingRelationshipAdminFromJson(o) {
    return {};
}
export function embeddingCitationToJson(m) {
    const o = {};
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    return o;
}
export function embeddingCitationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        link: (_a = o['link']) !== null && _a !== void 0 ? _a : '',
        title: (_b = o['title']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        fileUrl: (_d = o['fileUrl']) !== null && _d !== void 0 ? _d : '',
    };
}
export function removeKnowledgeBaseFromAppsInNamespaceRequestToJson(m) {
    const o = {};
    if (m.knowledgeBase !== undefined)
        o['knowledgeBase'] = knowledgeBaseKeyToJson(m.knowledgeBase);
    if (m.appNamespace !== undefined)
        o['appNamespace'] = namespaceToJson(m.appNamespace);
    return o;
}
export function removeKnowledgeBaseFromAppsInNamespaceRequestFromJson(o) {
    return {
        knowledgeBase: o['knowledgeBase'] ? knowledgeBaseKeyFromJson(o['knowledgeBase']) : undefined,
        appNamespace: o['appNamespace'] ? namespaceFromJson(o['appNamespace']) : undefined,
    };
}
export function removeKnowledgeBaseFromAppsInNamespaceResponseToJson(m) {
    const o = {};
    if (m.removedCount !== undefined)
        o['removedCount'] = m.removedCount;
    return o;
}
export function removeKnowledgeBaseFromAppsInNamespaceResponseFromJson(o) {
    var _a;
    return {
        removedCount: (_a = o['removedCount']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function knowledgeBaseGrantSpecToJson(m) {
    const o = {};
    if (m.sourceKb !== undefined)
        o['sourceKb'] = knowledgeBaseKeyToJson(m.sourceKb);
    if (m.targetNamespace !== undefined)
        o['targetNamespace'] = namespaceToJson(m.targetNamespace);
    if (m.targetScope !== undefined)
        o['targetScope'] = m.targetScope;
    if (m.grantedByNamespace !== undefined)
        o['grantedByNamespace'] = namespaceToJson(m.grantedByNamespace);
    return o;
}
export function knowledgeBaseGrantSpecFromJson(o) {
    var _a;
    return {
        sourceKb: o['sourceKb'] ? knowledgeBaseKeyFromJson(o['sourceKb']) : undefined,
        targetNamespace: o['targetNamespace'] ? namespaceFromJson(o['targetNamespace']) : undefined,
        targetScope: (_a = o['targetScope']) !== null && _a !== void 0 ? _a : 'TARGET_SCOPE_INVALID',
        grantedByNamespace: o['grantedByNamespace'] ? namespaceFromJson(o['grantedByNamespace']) : undefined,
    };
}
export function createKnowledgeBaseGrantRequestToJson(m) {
    const o = {};
    if (m.grant !== undefined)
        o['grant'] = knowledgeBaseGrantSpecToJson(m.grant);
    return o;
}
export function createKnowledgeBaseGrantRequestFromJson(o) {
    return {
        grant: o['grant'] ? knowledgeBaseGrantSpecFromJson(o['grant']) : undefined,
    };
}
export function createKnowledgeBaseGrantResponseToJson(m) {
    const o = {};
    if (m.grant !== undefined)
        o['grant'] = knowledgeBaseGrantToJson(m.grant);
    return o;
}
export function createKnowledgeBaseGrantResponseFromJson(o) {
    return {
        grant: o['grant'] ? knowledgeBaseGrantFromJson(o['grant']) : undefined,
    };
}
export function revokeKnowledgeBaseGrantsRequestToJson(m) {
    const o = {};
    if (m.sourceKb !== undefined)
        o['sourceKb'] = knowledgeBaseKeyToJson(m.sourceKb);
    if (m.issuerNamespace !== undefined)
        o['issuerNamespace'] = namespaceToJson(m.issuerNamespace);
    if (m.targetNamespace !== undefined)
        o['targetNamespace'] = namespaceToJson(m.targetNamespace);
    if (m.targetScope !== undefined)
        o['targetScope'] = m.targetScope;
    return o;
}
export function revokeKnowledgeBaseGrantsRequestFromJson(o) {
    var _a;
    return {
        sourceKb: o['sourceKb'] ? knowledgeBaseKeyFromJson(o['sourceKb']) : undefined,
        issuerNamespace: o['issuerNamespace'] ? namespaceFromJson(o['issuerNamespace']) : undefined,
        targetNamespace: o['targetNamespace'] ? namespaceFromJson(o['targetNamespace']) : undefined,
        targetScope: (_a = o['targetScope']) !== null && _a !== void 0 ? _a : 'TARGET_SCOPE_INVALID',
    };
}
export function revokeKnowledgeBaseGrantResultToJson(m) {
    const o = {};
    if (m.grant !== undefined)
        o['grant'] = knowledgeBaseGrantToJson(m.grant);
    if (m.statusCode !== undefined)
        o['statusCode'] = m.statusCode;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.dependents !== undefined)
        o['dependents'] = dependentSummaryToJson(m.dependents);
    return o;
}
export function revokeKnowledgeBaseGrantResultFromJson(o) {
    var _a, _b;
    return {
        grant: o['grant'] ? knowledgeBaseGrantFromJson(o['grant']) : undefined,
        statusCode: (_a = o['statusCode']) !== null && _a !== void 0 ? _a : 'OK',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
        dependents: o['dependents'] ? dependentSummaryFromJson(o['dependents']) : undefined,
    };
}
export function revokeKnowledgeBaseGrantsResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => revokeKnowledgeBaseGrantResultToJson(e));
    }
    return o;
}
export function revokeKnowledgeBaseGrantsResponseFromJson(o) {
    var _a;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => revokeKnowledgeBaseGrantResultFromJson(e)),
    };
}
export function listKnowledgeBaseGrantDependentsRequestToJson(m) {
    const o = {};
    if (m.sourceKb !== undefined)
        o['sourceKb'] = knowledgeBaseKeyToJson(m.sourceKb);
    if (m.issuerNamespace !== undefined)
        o['issuerNamespace'] = namespaceToJson(m.issuerNamespace);
    if (m.targetNamespace !== undefined)
        o['targetNamespace'] = namespaceToJson(m.targetNamespace);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.targetScope !== undefined)
        o['targetScope'] = m.targetScope;
    return o;
}
export function listKnowledgeBaseGrantDependentsRequestFromJson(o) {
    var _a;
    return {
        sourceKb: o['sourceKb'] ? knowledgeBaseKeyFromJson(o['sourceKb']) : undefined,
        issuerNamespace: o['issuerNamespace'] ? namespaceFromJson(o['issuerNamespace']) : undefined,
        targetNamespace: o['targetNamespace'] ? namespaceFromJson(o['targetNamespace']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        targetScope: (_a = o['targetScope']) !== null && _a !== void 0 ? _a : 'TARGET_SCOPE_INVALID',
    };
}
export function knowledgeBaseGrantWithDependentsToJson(m) {
    const o = {};
    if (m.grant !== undefined)
        o['grant'] = knowledgeBaseGrantToJson(m.grant);
    if (m.dependents !== undefined)
        o['dependents'] = dependentSummaryToJson(m.dependents);
    return o;
}
export function knowledgeBaseGrantWithDependentsFromJson(o) {
    return {
        grant: o['grant'] ? knowledgeBaseGrantFromJson(o['grant']) : undefined,
        dependents: o['dependents'] ? dependentSummaryFromJson(o['dependents']) : undefined,
    };
}
export function listKnowledgeBaseGrantDependentsResponseToJson(m) {
    const o = {};
    if (m.grants !== undefined) {
        o['grants'] = m.grants.map(e => knowledgeBaseGrantWithDependentsToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKnowledgeBaseGrantDependentsResponseFromJson(o) {
    var _a;
    return {
        grants: ((_a = o['grants']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeBaseGrantWithDependentsFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listKnowledgeBaseGrantsForKnowledgeBaseRequestToJson(m) {
    const o = {};
    if (m.sourceKb !== undefined)
        o['sourceKb'] = knowledgeBaseKeyToJson(m.sourceKb);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listKnowledgeBaseGrantsForKnowledgeBaseRequestFromJson(o) {
    return {
        sourceKb: o['sourceKb'] ? knowledgeBaseKeyFromJson(o['sourceKb']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listKnowledgeBaseGrantsForKnowledgeBaseResponseToJson(m) {
    const o = {};
    if (m.grants !== undefined) {
        o['grants'] = m.grants.map(e => knowledgeBaseGrantToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKnowledgeBaseGrantsForKnowledgeBaseResponseFromJson(o) {
    var _a;
    return {
        grants: ((_a = o['grants']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeBaseGrantFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listKnowledgeBaseGrantsForNamespaceRequestToJson(m) {
    const o = {};
    if (m.targetNamespace !== undefined)
        o['targetNamespace'] = namespaceToJson(m.targetNamespace);
    if (m.includeInherited !== undefined)
        o['includeInherited'] = m.includeInherited;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listKnowledgeBaseGrantsForNamespaceRequestFromJson(o) {
    var _a;
    return {
        targetNamespace: o['targetNamespace'] ? namespaceFromJson(o['targetNamespace']) : undefined,
        includeInherited: (_a = o['includeInherited']) !== null && _a !== void 0 ? _a : false,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listKnowledgeBaseGrantsForNamespaceResponseToJson(m) {
    const o = {};
    if (m.grants !== undefined) {
        o['grants'] = m.grants.map(e => knowledgeBaseGrantToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKnowledgeBaseGrantsForNamespaceResponseFromJson(o) {
    var _a;
    return {
        grants: ((_a = o['grants']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeBaseGrantFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function createEmbeddingRequestToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.metadata !== undefined)
        o['metadata'] = embeddingMetadataToJson(m.metadata);
    return o;
}
export function createEmbeddingRequestFromJson(o) {
    var _a;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        metadata: o['metadata'] ? embeddingMetadataFromJson(o['metadata']) : undefined,
    };
}
export function createEmbeddingResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createEmbeddingResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getEmbeddingRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getEmbeddingRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getEmbeddingResponseToJson(m) {
    const o = {};
    if (m.embedding !== undefined)
        o['embedding'] = embeddingToJson(m.embedding);
    return o;
}
export function getEmbeddingResponseFromJson(o) {
    return {
        embedding: o['embedding'] ? embeddingFromJson(o['embedding']) : undefined,
    };
}
export function updateEmbeddingRequestToJson(m) {
    const o = {};
    if (m.embedding !== undefined)
        o['embedding'] = embeddingToJson(m.embedding);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateEmbeddingRequestFromJson(o) {
    return {
        embedding: o['embedding'] ? embeddingFromJson(o['embedding']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteEmbeddingRequestToJson(m) {
    const o = {};
    if (m.embeddingId !== undefined)
        o['embeddingId'] = m.embeddingId;
    return o;
}
export function deleteEmbeddingRequestFromJson(o) {
    var _a;
    return {
        embeddingId: (_a = o['embeddingId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listEmbeddingsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listEmbeddingsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listEmbeddingsRequestFromJson(o) {
    return {
        filters: o['filters'] ? listEmbeddingsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listEmbeddingsRequestFiltersToJson(m) {
    const o = {};
    if (m.relationship !== undefined)
        o['relationship'] = embeddingRelationshipToJson(m.relationship);
    if (m.sourceType !== undefined) {
        o['sourceType'] = m.sourceType.map(e => e);
    }
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.associatedAppId !== undefined)
        o['associatedAppId'] = m.associatedAppId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => tagToJson(e));
    }
    return o;
}
export function listEmbeddingsRequestFiltersFromJson(o) {
    var _a, _b, _c, _d;
    return {
        relationship: o['relationship'] ? embeddingRelationshipFromJson(o['relationship']) : undefined,
        sourceType: ((_a = o['sourceType']) !== null && _a !== void 0 ? _a : []).map(e => e),
        vendorModel: (_b = o['vendorModel']) !== null && _b !== void 0 ? _b : 'EMBEDDING_MODEL_INVALID',
        associatedAppId: (_c = o['associatedAppId']) !== null && _c !== void 0 ? _c : '',
        tags: ((_d = o['tags']) !== null && _d !== void 0 ? _d : []).map(e => tagFromJson(e)),
    };
}
export function listEmbeddingsResponseToJson(m) {
    const o = {};
    if (m.embeddings !== undefined) {
        o['embeddings'] = m.embeddings.map(e => embeddingToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listEmbeddingsResponseFromJson(o) {
    var _a;
    return {
        embeddings: ((_a = o['embeddings']) !== null && _a !== void 0 ? _a : []).map(e => embeddingFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function findSimilarEmbeddingsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = findSimilarEmbeddingsRequestFiltersToJson(m.filters);
    if (m.query !== undefined)
        o['query'] = m.query;
    if (m.limit !== undefined)
        o['limit'] = m.limit;
    if (m.rerankOptions !== undefined)
        o['rerankOptions'] = findSimilarEmbeddingsRequestRerankOptionsToJson(m.rerankOptions);
    return o;
}
export function findSimilarEmbeddingsRequestFromJson(o) {
    var _a, _b;
    return {
        filters: o['filters'] ? findSimilarEmbeddingsRequestFiltersFromJson(o['filters']) : undefined,
        query: (_a = o['query']) !== null && _a !== void 0 ? _a : '',
        limit: (_b = o['limit']) !== null && _b !== void 0 ? _b : 0,
        rerankOptions: o['rerankOptions'] ? findSimilarEmbeddingsRequestRerankOptionsFromJson(o['rerankOptions']) : undefined,
    };
}
export function findSimilarEmbeddingsRequestFiltersToJson(m) {
    const o = {};
    if (m.relationship !== undefined)
        o['relationship'] = embeddingRelationshipToJson(m.relationship);
    if (m.sourceType !== undefined) {
        o['sourceType'] = m.sourceType.map(e => e);
    }
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.associatedAppId !== undefined)
        o['associatedAppId'] = m.associatedAppId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => tagToJson(e));
    }
    return o;
}
export function findSimilarEmbeddingsRequestFiltersFromJson(o) {
    var _a, _b, _c, _d;
    return {
        relationship: o['relationship'] ? embeddingRelationshipFromJson(o['relationship']) : undefined,
        sourceType: ((_a = o['sourceType']) !== null && _a !== void 0 ? _a : []).map(e => e),
        vendorModel: (_b = o['vendorModel']) !== null && _b !== void 0 ? _b : 'EMBEDDING_MODEL_INVALID',
        associatedAppId: (_c = o['associatedAppId']) !== null && _c !== void 0 ? _c : '',
        tags: ((_d = o['tags']) !== null && _d !== void 0 ? _d : []).map(e => tagFromJson(e)),
    };
}
export function findSimilarEmbeddingsRequestRerankOptionsToJson(m) {
    const o = {};
    if (m.method !== undefined)
        o['method'] = m.method;
    return o;
}
export function findSimilarEmbeddingsRequestRerankOptionsFromJson(o) {
    var _a;
    return {
        method: (_a = o['method']) !== null && _a !== void 0 ? _a : 'EMBEDDING_RERANKER_METHOD_INVALID',
    };
}
export function findSimilarEmbeddingsResponseToJson(m) {
    const o = {};
    if (m.embeddings !== undefined) {
        o['embeddings'] = m.embeddings.map(e => findSimilarEmbeddingsResponseMatchToJson(e));
    }
    return o;
}
export function findSimilarEmbeddingsResponseFromJson(o) {
    var _a;
    return {
        embeddings: ((_a = o['embeddings']) !== null && _a !== void 0 ? _a : []).map(e => findSimilarEmbeddingsResponseMatchFromJson(e)),
    };
}
export function findSimilarEmbeddingsResponseMatchToJson(m) {
    const o = {};
    if (m.embedding !== undefined)
        o['embedding'] = embeddingToJson(m.embedding);
    if (m.similarity !== undefined)
        o['similarity'] = m.similarity;
    return o;
}
export function findSimilarEmbeddingsResponseMatchFromJson(o) {
    var _a;
    return {
        embedding: o['embedding'] ? embeddingFromJson(o['embedding']) : undefined,
        similarity: (_a = o['similarity']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function scrapeWebsiteRequestToJson(m) {
    const o = {};
    if (m.knowledgeSourceId !== undefined)
        o['knowledgeSourceId'] = m.knowledgeSourceId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.options !== undefined)
        o['options'] = scrapeWebsiteRequestOptionsToJson(m.options);
    return o;
}
export function scrapeWebsiteRequestFromJson(o) {
    var _a;
    return {
        knowledgeSourceId: (_a = o['knowledgeSourceId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        options: o['options'] ? scrapeWebsiteRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function scrapeWebsiteRequestOptionsToJson(m) {
    const o = {};
    if (m.specificUrls !== undefined) {
        o['specificUrls'] = m.specificUrls.map(e => e);
    }
    if (m.bypassCache !== undefined)
        o['bypassCache'] = m.bypassCache;
    return o;
}
export function scrapeWebsiteRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        specificUrls: ((_a = o['specificUrls']) !== null && _a !== void 0 ? _a : []).map(e => e),
        bypassCache: (_b = o['bypassCache']) !== null && _b !== void 0 ? _b : false,
    };
}
export function scrapeWebsiteResponseToJson(m) {
    const o = {};
    return o;
}
export function scrapeWebsiteResponseFromJson(o) {
    return {};
}
export function refreshBusinessProfileEmbeddingsRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function refreshBusinessProfileEmbeddingsRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function chatMessageToJson(m) {
    const o = {};
    if (m.role !== undefined)
        o['role'] = m.role;
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function chatMessageFromJson(o) {
    var _a, _b;
    return {
        role: (_a = o['role']) !== null && _a !== void 0 ? _a : 'CHAT_MESSAGE_ROLE_INVALID',
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
    };
}
export function chatAnswerCitationToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function chatAnswerCitationFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'EMBEDDING_SOURCE_TYPE_INVALID',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        link: (_c = o['link']) !== null && _c !== void 0 ? _c : '',
        title: (_d = o['title']) !== null && _d !== void 0 ? _d : '',
        content: (_e = o['content']) !== null && _e !== void 0 ? _e : '',
    };
}
export function chatBookingOptionToJson(m) {
    const o = {};
    if (m.displayText !== undefined)
        o['displayText'] = m.displayText;
    if (m.scheduleId !== undefined)
        o['scheduleId'] = m.scheduleId;
    return o;
}
export function chatBookingOptionFromJson(o) {
    var _a, _b;
    return {
        displayText: (_a = o['displayText']) !== null && _a !== void 0 ? _a : '',
        scheduleId: (_b = o['scheduleId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function generateChatAnswerWithEmbeddingsRequestToJson(m) {
    const o = {};
    if (m.appKey !== undefined)
        o['appKey'] = appKeyToJson(m.appKey);
    if (m.chatHistory !== undefined) {
        o['chatHistory'] = m.chatHistory.map(e => chatMessageToJson(e));
    }
    if (m.systemPrompt !== undefined)
        o['systemPrompt'] = m.systemPrompt;
    if (m.additionalInstructions !== undefined)
        o['additionalInstructions'] = m.additionalInstructions;
    if (m.options !== undefined)
        o['options'] = generateChatAnswerWithEmbeddingsRequestOptionsToJson(m.options);
    if (m.appKeyV2 !== undefined)
        o['appKeyV2'] = appKeyV2ToJson(m.appKeyV2);
    return o;
}
export function generateChatAnswerWithEmbeddingsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appKey: o['appKey'] ? appKeyFromJson(o['appKey']) : undefined,
        chatHistory: ((_a = o['chatHistory']) !== null && _a !== void 0 ? _a : []).map(e => chatMessageFromJson(e)),
        systemPrompt: (_b = o['systemPrompt']) !== null && _b !== void 0 ? _b : '',
        additionalInstructions: (_c = o['additionalInstructions']) !== null && _c !== void 0 ? _c : '',
        options: o['options'] ? generateChatAnswerWithEmbeddingsRequestOptionsFromJson(o['options']) : undefined,
        appKeyV2: o['appKeyV2'] ? appKeyV2FromJson(o['appKeyV2']) : undefined,
    };
}
export function generateChatAnswerWithEmbeddingsRequestOptionsToJson(m) {
    const o = {};
    if (m.includeAllCitations !== undefined)
        o['includeAllCitations'] = m.includeAllCitations;
    if (m.enableAsyncFunctions !== undefined)
        o['enableAsyncFunctions'] = m.enableAsyncFunctions;
    if (m.maxTokens !== undefined)
        o['maxTokens'] = m.maxTokens;
    return o;
}
export function generateChatAnswerWithEmbeddingsRequestOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        includeAllCitations: (_a = o['includeAllCitations']) !== null && _a !== void 0 ? _a : false,
        enableAsyncFunctions: (_b = o['enableAsyncFunctions']) !== null && _b !== void 0 ? _b : false,
        maxTokens: (_c = o['maxTokens']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function generateChatAnswerWithEmbeddingsResponseToJson(m) {
    const o = {};
    if (m.answer !== undefined)
        o['answer'] = m.answer;
    if (m.citations !== undefined) {
        o['citations'] = m.citations.map(e => chatAnswerCitationToJson(e));
    }
    if (m.bookingOptions !== undefined) {
        o['bookingOptions'] = m.bookingOptions.map(e => chatBookingOptionToJson(e));
    }
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.pendingJobId !== undefined)
        o['pendingJobId'] = m.pendingJobId;
    return o;
}
export function generateChatAnswerWithEmbeddingsResponseFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        answer: (_a = o['answer']) !== null && _a !== void 0 ? _a : '',
        citations: ((_b = o['citations']) !== null && _b !== void 0 ? _b : []).map(e => chatAnswerCitationFromJson(e)),
        bookingOptions: ((_c = o['bookingOptions']) !== null && _c !== void 0 ? _c : []).map(e => chatBookingOptionFromJson(e)),
        metadata: ((_d = o['metadata']) !== null && _d !== void 0 ? _d : []).map(e => keyValuePairFromJson(e)),
        pendingJobId: (_e = o['pendingJobId']) !== null && _e !== void 0 ? _e : '',
    };
}
export function keyValuePairToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function keyValuePairFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function functionExecutionJobResultToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function functionExecutionJobResultFromJson(o) {
    var _a, _b;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
    };
}
export function functionExecutionJobToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.result !== undefined)
        o['result'] = functionExecutionJobResultToJson(m.result);
    if (m.nextJobId !== undefined)
        o['nextJobId'] = m.nextJobId;
    return o;
}
export function functionExecutionJobFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'FUNCTION_EXECUTION_JOB_STATUS_INVALID',
        result: o['result'] ? functionExecutionJobResultFromJson(o['result']) : undefined,
        nextJobId: (_c = o['nextJobId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getFunctionExecutionJobRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getFunctionExecutionJobRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getFunctionExecutionJobResponseToJson(m) {
    const o = {};
    if (m.job !== undefined)
        o['job'] = functionExecutionJobToJson(m.job);
    return o;
}
export function getFunctionExecutionJobResponseFromJson(o) {
    return {
        job: o['job'] ? functionExecutionJobFromJson(o['job']) : undefined,
    };
}
export function createKnowledgeBaseRequestToJson(m) {
    const o = {};
    if (m.knowledgeBase !== undefined)
        o['knowledgeBase'] = knowledgeBaseToJson(m.knowledgeBase);
    return o;
}
export function createKnowledgeBaseRequestFromJson(o) {
    return {
        knowledgeBase: o['knowledgeBase'] ? knowledgeBaseFromJson(o['knowledgeBase']) : undefined,
    };
}
export function createKnowledgeBaseResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function createKnowledgeBaseResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getKnowledgeBaseRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.includeKnowledgeSourceKeys !== undefined)
        o['includeKnowledgeSourceKeys'] = m.includeKnowledgeSourceKeys;
    return o;
}
export function getKnowledgeBaseRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        includeKnowledgeSourceKeys: (_b = o['includeKnowledgeSourceKeys']) !== null && _b !== void 0 ? _b : false,
    };
}
export function getKnowledgeBaseResponseToJson(m) {
    const o = {};
    if (m.knowledgeBase !== undefined)
        o['knowledgeBase'] = knowledgeBaseToJson(m.knowledgeBase);
    return o;
}
export function getKnowledgeBaseResponseFromJson(o) {
    return {
        knowledgeBase: o['knowledgeBase'] ? knowledgeBaseFromJson(o['knowledgeBase']) : undefined,
    };
}
export function updateKnowledgeBaseRequestToJson(m) {
    const o = {};
    if (m.knowledgeBase !== undefined)
        o['knowledgeBase'] = knowledgeBaseToJson(m.knowledgeBase);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateKnowledgeBaseRequestFromJson(o) {
    return {
        knowledgeBase: o['knowledgeBase'] ? knowledgeBaseFromJson(o['knowledgeBase']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteKnowledgeBaseRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteKnowledgeBaseRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listKnowledgeBasesRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listKnowledgeBasesRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.includeKnowledgeSourceKeys !== undefined)
        o['includeKnowledgeSourceKeys'] = m.includeKnowledgeSourceKeys;
    return o;
}
export function listKnowledgeBasesRequestFromJson(o) {
    var _a;
    return {
        filters: o['filters'] ? listKnowledgeBasesRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        includeKnowledgeSourceKeys: (_a = o['includeKnowledgeSourceKeys']) !== null && _a !== void 0 ? _a : false,
    };
}
export function listKnowledgeBasesRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listKnowledgeBasesRequestFiltersFromJson(o) {
    var _a;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listKnowledgeBasesResponseToJson(m) {
    const o = {};
    if (m.knowledgeBases !== undefined) {
        o['knowledgeBases'] = m.knowledgeBases.map(e => knowledgeBaseToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKnowledgeBasesResponseFromJson(o) {
    var _a;
    return {
        knowledgeBases: ((_a = o['knowledgeBases']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeBaseFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function createKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.knowledgeSource !== undefined)
        o['knowledgeSource'] = knowledgeSourceToJson(m.knowledgeSource);
    return o;
}
export function createKnowledgeSourceRequestFromJson(o) {
    return {
        knowledgeSource: o['knowledgeSource'] ? knowledgeSourceFromJson(o['knowledgeSource']) : undefined,
    };
}
export function createKnowledgeSourceResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function createKnowledgeSourceResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.includeKnowledgeBaseKeys !== undefined)
        o['includeKnowledgeBaseKeys'] = m.includeKnowledgeBaseKeys;
    return o;
}
export function getKnowledgeSourceRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        includeKnowledgeBaseKeys: (_b = o['includeKnowledgeBaseKeys']) !== null && _b !== void 0 ? _b : false,
    };
}
export function getKnowledgeSourceResponseToJson(m) {
    const o = {};
    if (m.knowledgeSource !== undefined)
        o['knowledgeSource'] = knowledgeSourceToJson(m.knowledgeSource);
    return o;
}
export function getKnowledgeSourceResponseFromJson(o) {
    return {
        knowledgeSource: o['knowledgeSource'] ? knowledgeSourceFromJson(o['knowledgeSource']) : undefined,
    };
}
export function updateKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.knowledgeSource !== undefined)
        o['knowledgeSource'] = knowledgeSourceToJson(m.knowledgeSource);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateKnowledgeSourceRequestFromJson(o) {
    return {
        knowledgeSource: o['knowledgeSource'] ? knowledgeSourceFromJson(o['knowledgeSource']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function deleteKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteKnowledgeSourceRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listKnowledgeSourcesRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listKnowledgeSourcesRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.includeKnowledgeBaseKeys !== undefined)
        o['includeKnowledgeBaseKeys'] = m.includeKnowledgeBaseKeys;
    return o;
}
export function listKnowledgeSourcesRequestFromJson(o) {
    var _a;
    return {
        filters: o['filters'] ? listKnowledgeSourcesRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        includeKnowledgeBaseKeys: (_a = o['includeKnowledgeBaseKeys']) !== null && _a !== void 0 ? _a : false,
    };
}
export function listKnowledgeSourcesRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.configTypes !== undefined) {
        o['configTypes'] = m.configTypes.map(e => e);
    }
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listKnowledgeSourcesRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        configTypes: ((_a = o['configTypes']) !== null && _a !== void 0 ? _a : []).map(e => e),
        searchTerm: (_b = o['searchTerm']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listKnowledgeSourcesResponseToJson(m) {
    const o = {};
    if (m.knowledgeSources !== undefined) {
        o['knowledgeSources'] = m.knowledgeSources.map(e => knowledgeSourceToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listKnowledgeSourcesResponseFromJson(o) {
    var _a;
    return {
        knowledgeSources: ((_a = o['knowledgeSources']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeSourceFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function upsertAppRequestToJson(m) {
    const o = {};
    if (m.app !== undefined)
        o['app'] = appToJson(m.app);
    return o;
}
export function upsertAppRequestFromJson(o) {
    return {
        app: o['app'] ? appFromJson(o['app']) : undefined,
    };
}
export function getAppRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.includeKnowledgeBaseKeys !== undefined)
        o['includeKnowledgeBaseKeys'] = m.includeKnowledgeBaseKeys;
    if (m.includeCrossNamespace !== undefined)
        o['includeCrossNamespace'] = m.includeCrossNamespace;
    return o;
}
export function getAppRequestFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        includeKnowledgeBaseKeys: (_b = o['includeKnowledgeBaseKeys']) !== null && _b !== void 0 ? _b : false,
        includeCrossNamespace: (_c = o['includeCrossNamespace']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getAppResponseToJson(m) {
    const o = {};
    if (m.app !== undefined)
        o['app'] = appToJson(m.app);
    return o;
}
export function getAppResponseFromJson(o) {
    return {
        app: o['app'] ? appFromJson(o['app']) : undefined,
    };
}
export function deleteAppRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteAppRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listAppsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listAppsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.includeKnowledgeBaseKeys !== undefined)
        o['includeKnowledgeBaseKeys'] = m.includeKnowledgeBaseKeys;
    if (m.includeCrossNamespace !== undefined)
        o['includeCrossNamespace'] = m.includeCrossNamespace;
    return o;
}
export function listAppsRequestFromJson(o) {
    var _a, _b;
    return {
        filters: o['filters'] ? listAppsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        includeKnowledgeBaseKeys: (_a = o['includeKnowledgeBaseKeys']) !== null && _a !== void 0 ? _a : false,
        includeCrossNamespace: (_b = o['includeCrossNamespace']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listAppsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function listAppsRequestFiltersFromJson(o) {
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listAppsResponseToJson(m) {
    const o = {};
    if (m.apps !== undefined) {
        o['apps'] = m.apps.map(e => appToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listAppsResponseFromJson(o) {
    var _a;
    return {
        apps: ((_a = o['apps']) !== null && _a !== void 0 ? _a : []).map(e => appFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listAllKnowledgeSourcesForAppRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.filters !== undefined)
        o['filters'] = listAllKnowledgeSourcesForAppRequestFiltersToJson(m.filters);
    return o;
}
export function listAllKnowledgeSourcesForAppRequestFromJson(o) {
    var _a;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        filters: o['filters'] ? listAllKnowledgeSourcesForAppRequestFiltersFromJson(o['filters']) : undefined,
    };
}
export function listAllKnowledgeSourcesForAppRequestFiltersToJson(m) {
    const o = {};
    if (m.configTypes !== undefined) {
        o['configTypes'] = m.configTypes.map(e => e);
    }
    if (m.includeCrossNamespace !== undefined)
        o['includeCrossNamespace'] = m.includeCrossNamespace;
    return o;
}
export function listAllKnowledgeSourcesForAppRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        configTypes: ((_a = o['configTypes']) !== null && _a !== void 0 ? _a : []).map(e => e),
        includeCrossNamespace: (_b = o['includeCrossNamespace']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listAllKnowledgeSourcesForAppResponseToJson(m) {
    const o = {};
    if (m.knowledgeSources !== undefined) {
        o['knowledgeSources'] = m.knowledgeSources.map(e => knowledgeSourceToJson(e));
    }
    return o;
}
export function listAllKnowledgeSourcesForAppResponseFromJson(o) {
    var _a;
    return {
        knowledgeSources: ((_a = o['knowledgeSources']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeSourceFromJson(e)),
    };
}
export function listAllAppsForKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.knowledgeSourceId !== undefined)
        o['knowledgeSourceId'] = m.knowledgeSourceId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.includeCrossNamespace !== undefined)
        o['includeCrossNamespace'] = m.includeCrossNamespace;
    return o;
}
export function listAllAppsForKnowledgeSourceRequestFromJson(o) {
    var _a, _b;
    return {
        knowledgeSourceId: (_a = o['knowledgeSourceId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        includeCrossNamespace: (_b = o['includeCrossNamespace']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listAllAppsForKnowledgeSourceResponseToJson(m) {
    const o = {};
    if (m.apps !== undefined) {
        o['apps'] = m.apps.map(e => appToJson(e));
    }
    return o;
}
export function listAllAppsForKnowledgeSourceResponseFromJson(o) {
    var _a;
    return {
        apps: ((_a = o['apps']) !== null && _a !== void 0 ? _a : []).map(e => appFromJson(e)),
    };
}
export function upsertKnowledgeForAppRequestToJson(m) {
    const o = {};
    if (m.app !== undefined)
        o['app'] = appToJson(m.app);
    if (m.knowledgeSourceKeys !== undefined) {
        o['knowledgeSourceKeys'] = m.knowledgeSourceKeys.map(e => knowledgeSourceKeyToJson(e));
    }
    if (m.knowledgeBaseKeys !== undefined) {
        o['knowledgeBaseKeys'] = m.knowledgeBaseKeys.map(e => knowledgeBaseKeyToJson(e));
    }
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function upsertKnowledgeForAppRequestFromJson(o) {
    var _a, _b;
    return {
        app: o['app'] ? appFromJson(o['app']) : undefined,
        knowledgeSourceKeys: ((_a = o['knowledgeSourceKeys']) !== null && _a !== void 0 ? _a : []).map(e => knowledgeSourceKeyFromJson(e)),
        knowledgeBaseKeys: ((_b = o['knowledgeBaseKeys']) !== null && _b !== void 0 ? _b : []).map(e => knowledgeBaseKeyFromJson(e)),
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function setAppsForKnowledgeSourceRequestToJson(m) {
    const o = {};
    if (m.knowledgeSourceKey !== undefined)
        o['knowledgeSourceKey'] = knowledgeSourceKeyToJson(m.knowledgeSourceKey);
    if (m.appKeys !== undefined) {
        o['appKeys'] = m.appKeys.map(e => appKeyToJson(e));
    }
    if (m.appKeysV2 !== undefined) {
        o['appKeysV2'] = m.appKeysV2.map(e => appKeyV2ToJson(e));
    }
    return o;
}
export function setAppsForKnowledgeSourceRequestFromJson(o) {
    var _a, _b;
    return {
        knowledgeSourceKey: o['knowledgeSourceKey'] ? knowledgeSourceKeyFromJson(o['knowledgeSourceKey']) : undefined,
        appKeys: ((_a = o['appKeys']) !== null && _a !== void 0 ? _a : []).map(e => appKeyFromJson(e)),
        appKeysV2: ((_b = o['appKeysV2']) !== null && _b !== void 0 ? _b : []).map(e => appKeyV2FromJson(e)),
    };
}
export function tuneAIModelRequestToJson(m) {
    const o = {};
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.outputPath !== undefined)
        o['outputPath'] = m.outputPath;
    if (m.queriesPath !== undefined)
        o['queriesPath'] = m.queriesPath;
    if (m.corpusPath !== undefined)
        o['corpusPath'] = m.corpusPath;
    if (m.trainingLabelPath !== undefined)
        o['trainingLabelPath'] = m.trainingLabelPath;
    if (m.modelDisplayName !== undefined)
        o['modelDisplayName'] = m.modelDisplayName;
    return o;
}
export function tuneAIModelRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        vendorModel: (_a = o['vendorModel']) !== null && _a !== void 0 ? _a : 'EMBEDDING_MODEL_INVALID',
        outputPath: (_b = o['outputPath']) !== null && _b !== void 0 ? _b : '',
        queriesPath: (_c = o['queriesPath']) !== null && _c !== void 0 ? _c : '',
        corpusPath: (_d = o['corpusPath']) !== null && _d !== void 0 ? _d : '',
        trainingLabelPath: (_e = o['trainingLabelPath']) !== null && _e !== void 0 ? _e : '',
        modelDisplayName: (_f = o['modelDisplayName']) !== null && _f !== void 0 ? _f : '',
    };
}
export function dismissKnowledgeSourceTrainingErrorRequestToJson(m) {
    const o = {};
    if (m.knowledgeSourceKey !== undefined)
        o['knowledgeSourceKey'] = knowledgeSourceKeyToJson(m.knowledgeSourceKey);
    return o;
}
export function dismissKnowledgeSourceTrainingErrorRequestFromJson(o) {
    return {
        knowledgeSourceKey: o['knowledgeSourceKey'] ? knowledgeSourceKeyFromJson(o['knowledgeSourceKey']) : undefined,
    };
}
